import React, { FC, useMemo } from 'react';
import classnames from 'classnames';
import { getItemLabel } from '../../../../../utils/path';
import { FileLabeledThumbnail } from '../../FileLabeledThumbnail';
import styles from '../FileThumbnail.scss';
import { IFileThumbnail } from '../../types';
import { isFailed as isFileFailed } from '../../../../../utils/media-manager-sdk/transcoding';
import { ErrorOverlay } from '../../../TranscodingOverlays';

export const DocumentThumbnail: FC<IFileThumbnail> = ({
  file,
  className,
  width,
  height,
  dataHook = 'document-file-thumbnail',
  labelClassName,
  thumbnailSize,
  saveRef,
  wrapperStyle,
}) => {
  const { isFailed } = useMemo(
    () => ({
      isFailed: isFileFailed(file),
    }),
    [file],
  );
  return (
    <div
      className={classnames(styles.thumbnailWrapper, {
        [styles.thumbnailWrapperError]: isFailed,
      })}
    >
      <FileLabeledThumbnail
        className={classnames(styles.thumbnail, styles.document, styles[thumbnailSize], className)}
        label={`.${getItemLabel(file)}`}
        width={width}
        height={height}
        labelClassName={labelClassName}
        saveRef={saveRef}
        dataHook={dataHook}
        style={wrapperStyle}
      />
      {isFailed && <ErrorOverlay />}
    </div>
  );
};
